import React from 'react'

const Footer = () => <footer className='ttu'>
  <p className='mb0-5'><a href='mailto:hello@56.digital'>hello@56.digital <br/></a></p>
  <p><a href='https://google.com' target='_blank' rel='noopener noreferrer'>205–25 Liberty St Toronto <br/> Ontario M6K 1A6</a></p>
</footer>

export default Footer
